import React, { useEffect, useState } from "react";
import { Layout, Drawer, Grid } from "antd";
const { useBreakpoint } = Grid;
import CustomerList from "../../components/CustomerList/CustomerList";
import ChatWindow from "../../components/ChatWindow/ChatWindow";
import useConversations from "../../hooks/useConversations";
import MetadataSection from "../playground/sections/MetaDataSection";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";

const { Content } = Layout;

const ChannelsComponent = ({
  selectedCustomerId,
  chatData,
  setChatData,
  customerMetaData,
  handleCustomerClick,
  messageText,
  setMessageText,
  handleSendMessage,
  messagesEndRef,
  content,
  setContent,
  chatWindowLoading,
  // isVerified,
  // setIsVerified,
  firstCustomerId,
  setFirstCustomerId,
  setSelectedCustomerId,
  scrollToBottom,
}) => {
  const screens = useBreakpoint();
  const isMobile = !screens.md;
  const [collapsed, setCollapsed] = useState(true);
  const [profile, setProfile] = useState("facebook");
  const [dateRange, setDateRange] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  const [customerInfo, setCustomerInfo] = useState();

  const [refreshCustomerList, setRefreshCustomerList] = useState(false);

  // ...   DRAWER
  const [visible, setVisible] = useState(false);
  const onClose = () => {
    setVisible(false);
  };
  const [drawerData, setDrawerData] = useState();

  const collapsedWidth = collapsed ? 80 : 150; // Adjust as needed

  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  // Initialize selectedCustomerId from URL if available
  const urlCustomerId = searchParams.get('customer');
  useEffect(() => {
    if (urlCustomerId && urlCustomerId !== selectedCustomerId) {
      setSelectedCustomerId(urlCustomerId);
    }
  }, [urlCustomerId, selectedCustomerId, setSelectedCustomerId]);

  const handleProfileChange = (value) => {
    setProfile(value);
    setSelectedCustomer(null); // Reset selected customer when channel changes
  };

  const handleDateChange = (dates) => {
    setDateRange(dates);
  };

  const handleSearch = (value) => {
    setSearchTerm(value);
  };

  // FilterModel ma implement vako le ya bata hatai deko

  // const navigate = useNavigate();
  // const location = useLocation();

  // useEffect(() => {
  //   if (location.state?.phoneID || location.state?.topic) {
  //     navigate(location.pathname, { replace: true });
  //   }
  // }, []);

  const { conversations } = useConversations(
    profile,
    dateRange,
    searchTerm,
    "asc", // Sort option
    true // useDummyData
  );

  return (
    <Layout
      style={{
        height: isMobile ? "100dvh" : "90vh",
        overflow: "hidden",
        background: "#fff", // Ensure background is white
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        border: isMobile ? "none" : "1px solid #f0f0f0",
        borderRadius: "12px",
      }}
    >
      {(!isMobile || !selectedCustomerId) && (
        <CustomerList
          setCustomerInfo={setCustomerInfo}
          selectedCustomerId={selectedCustomerId}
          handleCustomerClick={handleCustomerClick}
          conversations={conversations}
          profile={profile}
          dateRange={dateRange}
          searchTerm={searchTerm}
          handleProfileChange={handleProfileChange}
          handleDateChange={handleDateChange}
          handleSearch={handleSearch}
          selectedCustomer={selectedCustomer}
          setSelectedCustomer={setSelectedCustomer}
          // setIsVerified={setIsVerified}
          firstCustomerId={firstCustomerId}
          setFirstCustomerId={setFirstCustomerId}
          setSelectedCustomerId={setSelectedCustomerId}
          refreshCustomerList={refreshCustomerList}
          isMobile={isMobile}
        />
      )}
      {(!isMobile || selectedCustomerId) && (
        <ChatWindow
          customerInfo={customerInfo}
          setVisible={setVisible}
          setDrawerData={setDrawerData}
          chatData={chatData}
          setChatData={setChatData}
          customerMetaData={customerMetaData}
          selectedCustomerId={selectedCustomerId}
          messageText={messageText}
          setMessageText={setMessageText}
          handleSendMessage={handleSendMessage}
          messagesEndRef={messagesEndRef}
          content={content}
          setContent={setContent}
          chatWindowLoading={chatWindowLoading}
          // isVerified={isVerified}
          scrollToBottom={scrollToBottom}
          setRefreshCustomerList={setRefreshCustomerList}
          isMobile={isMobile}
          onBack={() => {
            setSelectedCustomerId(null);
            setSearchParams((params) => {
              params.delete("customer");
              return params;
            });
          }}
        />
      )}
      <Drawer
        visible={visible}
        onClose={onClose}
        title={<div>AI Actions</div>}
        placement="right"
        width={isMobile ? "100%" : 480}
      >
        <MetadataSection drawerData={drawerData} />
      </Drawer>
    </Layout>
  );
};

export default ChannelsComponent;
